module.exports = __webpack_public_path__ + "img/25.be9e846d.png";